import invariant from 'invariant';
import every from 'lodash/every';
import filter from 'lodash/filter';
/**
 * Checks if value contains all of the search parts. The search parts should be lowercase.
 *
 * @param value {string} - Value to search
 * @param searchParts {[]} - Array of string to search for
 */ export function isMatch(value, searchParts) {
    invariant(typeof value === 'string', 'Filter value must be a string.');
    const formattedLowerCase = value.toLowerCase();
    return every(searchParts, (f)=>formattedLowerCase.indexOf(f) !== -1);
}
/**
 * Returns the items matching the filter. If filter isn't defined, then all items are returned.
 * The formatter function must return a string representation of an item.
 *
 * @param items {[]} - Items to search.
 * @param value {string} - String to search for. Search values are separated by whitespace.
 * @param formatter {function} - Function that returns a string representation for each item.
 * @returns {[]}
 */ export function filterBySearch(items, value, formatter) {
    if (!value) {
        return items;
    }
    invariant(typeof value === 'string', 'Filter value must be a string');
    const searchParts = value.toLowerCase().split(/\s+/);
    return filter(items, (x)=>{
        const formatted = formatter(x);
        invariant(typeof formatted === 'string', 'The formatter function must return a string.');
        return isMatch(formatted, searchParts);
    });
}
